import React from 'react';
import { Chip } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import ArticleIcon from '@mui/icons-material/Article';
import PrintIcon from '@mui/icons-material/Print';
import PhoneIcon from '@mui/icons-material/Phone';
import CodeIcon from '@mui/icons-material/Code';
import { ReferralSource } from '~/types/transition';

interface SourceBadgeProps {
  source: ReferralSource;
  size?: 'small' | 'medium';
}

const SOURCE_CONFIG = {
  [ReferralSource.EMAIL]: { label: 'Email', icon: <EmailIcon />, color: '#1565c0', bg: '#e3f2fd' },
  [ReferralSource.EFAX]: { label: 'E-Fax', icon: <ArticleIcon />, color: '#00695c', bg: '#e0f2f1' },
  [ReferralSource.FAX]: { label: 'Fax', icon: <PrintIcon />, color: '#546e7a', bg: '#eceff1' },
  [ReferralSource.PHONE]: { label: 'Phone', icon: <PhoneIcon />, color: '#2e7d32', bg: '#e8f5e9' },
  [ReferralSource.API]: { label: 'API', icon: <CodeIcon />, color: '#6a1b9a', bg: '#f3e5f5' },
};

const SourceBadge: React.FC<SourceBadgeProps> = ({ source, size = 'small' }) => {
  const config = SOURCE_CONFIG[source];
  return (
    <Chip
      icon={React.cloneElement(config.icon, { style: { color: config.color, fontSize: '0.85rem' } })}
      label={config.label}
      size={size}
      sx={{
        backgroundColor: config.bg,
        color: config.color,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: size === 'small' ? 22 : 28,
        '& .MuiChip-icon': { color: config.color },
      }}
    />
  );
};

export default SourceBadge;
